<template>

<v-autocomplete
@change="select"
v-model="contact"
rounded flat solo-inverted dense
return-object
hide-no-data
full-width
prepend-inner-icon="search"
label="Search..."
style="max-width:200px;margin-top:25px"
item-text="fullName"
item-value="objectID"
:items="contacts"
:search-input.sync="search"
no-filter
ref="contactSearch"
>

    <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-avatar>
                <img :src="data.item.image">
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-html="data.item.fullNameHighlighted"></v-list-item-title>
                    <v-list-item-subtitle>{{bestContact(data.item)}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                <v-btn icon @click.stop="jump(data.item)">
                    <v-icon color="grey">mdi-forwardburger</v-icon>
                </v-btn>
                </v-list-item-action>
            </template>
    </template>

</v-autocomplete>

</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import AlgoliaHelpers from '../helpers/AlgoliaHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import AlertHelpers from '../helpers/AlertHelpers'

export default {
    data() {
        return {
            contacts: [],
            search: '',
            contact: {},
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        select(newVal) {
            this.$emit('select', newVal)
            this.search = ""
        },
        jump(newVal) {
            this.$emit('jump', newVal)
            this.search = ""
        },
        runSearch() {
            const index = AlgoliaHelpers.getContactIndex(DataHelpers.getTenantKey())
            index.search(this.search, {hitsPerPage:15}).then(result => {
                console.log(result)
                this.contacts = result.hits.map(c => {
                    return {
                        ...c,
                        fullName: c.firstName + ' ' + c.lastName,
                        fullNameHighlighted: c._highlightResult.firstName.value + ' ' + c._highlightResult.lastName.value
                    }
                })
            })
        },
        bestContact(contact) {
            return ContactHelpers.bestNumber(contact)
        },
        focus() {
            this.$refs.contactSearch.focus()
        }
    },

    created() {
        
    },

    watch: {
        'search': {
            handler: function(newVal) {
                if(newVal)
                    this.runSearch()
                else
                    this.contacts = []
            }
        }
    }
}
</script>

<style scoped>

   
</style>




// WEBPACK FOOTER //
// AlgoliaContacts.vue?b8d11134